import { render, staticRenderFns } from "./activities-edit.vue?vue&type=template&id=2bd9e7e4&scoped=true"
import script from "./activities-edit.vue?vue&type=script&lang=js"
export * from "./activities-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd9e7e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bd9e7e4')) {
      api.createRecord('2bd9e7e4', component.options)
    } else {
      api.reload('2bd9e7e4', component.options)
    }
    module.hot.accept("./activities-edit.vue?vue&type=template&id=2bd9e7e4&scoped=true", function () {
      api.rerender('2bd9e7e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/components/activities/activities-edit.vue"
export default component.exports